import { UploadFileValue } from './types';

/**
 * Convert upload file value to API input format
 */
export const toUploadFileInput = (value: UploadFileValue) => {
    if (!value) return undefined;
    if (value instanceof File) return { file: value };
    if (value?._id) return { _id: value._id };
    if (value?.url) return { url: value.url };
    return undefined;
};

/**
 * Convert multiple upload files to API input format
 */
export const toUploadFilesInput = (
    values: Array<File | { _id?: string; url?: string; name?: string; size?: number; mimetype?: string }> | undefined,
) => {
    if (!values || values.length === 0) return undefined;
    return values
        .map(v => {
            if (v instanceof File) return { file: v };
            if (v?._id) return { _id: v._id };
            if (v?.url) return { url: v.url };
            return undefined;
        })
        .filter(Boolean);
};
